import {Box, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";


const MobileNav = () => {

  return (
    <Box sx={{
      "& .submenuList":{
        cursor:"none !important"
      }
    }}>
          {/* <Link to={"/"} style={{ lineHeight: "0" }}>
              {" "}
              <Typography component={"img"} src={logo} width={"180px"} />
            </Link>
      <IconButton
        aria-label="close"
        onClick={handleDrawerToggle("top", false)}
        title="Close"
        sx={{
          position: "absolute",
          right: "5px",
          color: "#782980",
          top: "5px",
          background: "#fff",
          "&:hover": {
            background: "#fff",
          },
     
        }}
      >
        <CloseIcon sx={{ fontSize: "1.1rem" }} />
      </IconButton> */}
      <Box
        // onClick={handleDrawerToggle}
        sx={{
          // textAlign: "center",
          display: "grid",
          flexDirection: "column",
          alignItems: "center",
          gap: "0.1rem",
          mt: "8rem",
          "& a": {
            // color: "#782980",
            color: "#014687",
            textDecoration: "none",
          },
          "& a:hover": {
            color: "#014687",
          },
       
          "& .submenuList": {
            display: "flex",
            justifyContent: "space-between",
            gap: "1rem",
            alignItems: "center",
            // background: "#782980",
            // color: "#782980",
            color: "#014687",
            padding: "0.4rem",
            borderRadius: "4px",
            fontFamily: "centuryGothic !important",
            "&:hover": {
              color: "#014687",
            },
          },
        }}
      >
    
        <Typography className={"submenuList"}>
          <Link to={"/"}>ABOUT</Link>
        </Typography>
        <Typography className={"submenuList"}>
          <Link to={"/service/individual"}>Individual Services</Link>
        </Typography>
        <Typography className={"submenuList"}>
          <Link to={"/service/provider"}>Provider Services</Link>
        </Typography>
     
    
      </Box>
    </Box>
  );
};

export default MobileNav;
